export default "__VITE_ASSET__BOvJeo59__"